import { PATHS, USER_ROLES } from 'src/common/constants';

export const sharedBottomLinks = [
  { id: 'settings', label: 'Settings', path: PATHS.SETTINGS, icon: 'cog' },
  {
    id: 'signOut',
    label: 'Sign Out',
    path: PATHS.AUTH_SIGN_OUT,
    icon: 'sign-out',
  },
];

export const adminBottomLinks = [
  {
    id: 'emailTemplates',
    label: 'Email Templates',
    path: PATHS.EMAIL_TEMPLATES,
    icon: 'envelope',
  },
  ...sharedBottomLinks,
];

export const adminTopLinks = [
  {
    id: 'serviceRequests',
    label: 'Service Requests',
    path: PATHS.SERVICE_REQUESTS_LIST,
    icon: 'wrench',
  },
  { id: 'calendar', label: 'Calendar', path: PATHS.CALENDAR, icon: 'calendar' },
  {
    id: 'properties',
    label: 'Properties',
    path: PATHS.PROPERTIES_LIST,
    icon: 'building',
    activePaths: ['/app/properties', '/app/suites', '/app/assets'],
  },
  {
    id: 'contacts',
    label: 'Contacts',
    path: PATHS.CONTACTS_LIST,
    icon: 'users',
  },
  {
    id: 'catalog',
    label: 'Catalog',
    path: PATHS.ITEMS_LIST,
    icon: 'boxes',
    activePaths: ['/app/catalog', '/app/items'],
  },
  {
    id: 'announcements',
    label: 'Announcements',
    path: PATHS.ANNOUNCEMENTS,
    icon: 'bullhorn',
  },
  {
    id: 'reporting',
    label: 'Reporting',
    path: PATHS.REPORTING,
    icon: 'chart-bar',
  },
  {
    id: 'onboarding',
    label: 'Homeowner Onboarding',
    path: PATHS.HOMEOWNER_ONBOARDING,
    icon: 'home',
  },
  { id: 'inbox', label: 'Inbox', path: PATHS.INBOX, icon: 'folder-open' },
  {
    id: 'outbox',
    label: 'Outbox',
    path: PATHS.OUTBOX,
    icon: 'paper-plane',
    // Property Developers share this sidebar, but the outbox API is Admin-only.
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
  },
  {
    id: 'downloadPdf',
    label: 'Download PDF Requests',
    path: PATHS.REQUEST,
    icon: 'cloud-download',
  },
];

// Correct config for Service Providers.
export const serviceProviderTopLinks = [
  {
    id: 'serviceRequests',
    label: 'Service Requests',
    path: PATHS.SERVICE_REQUESTS_LIST,
    icon: 'wrench',
  },
  { id: 'calendar', label: 'Calendar', path: PATHS.CALENDAR, icon: 'calendar' },
  { id: 'inbox', label: 'Inbox', path: PATHS.INBOX, icon: 'folder-open' },
  {
    id: 'downloadPdf',
    label: 'Download PDF Requests',
    path: PATHS.REQUEST,
    icon: 'cloud-download',
  },
];

// Correct config for strata managers.
export const strataManagerTopLinks = [
  {
    id: 'properties',
    label: 'Inventory and Areas',
    path: PATHS.PROPERTIES_LIST,
    icon: 'building',
    activePaths: ['/app/properties', '/app/suites', '/app/assets'],
  },
  { id: 'inbox', label: 'Inbox', path: PATHS.INBOX, icon: 'folder-open' },
  {
    id: 'downloadPdf',
    label: 'Download PDF Requests',
    path: PATHS.REQUEST,
    icon: 'cloud-download',
  },
];
